import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { CommentReferenceType } from '@amityco/js-sdk';
import { LazyRender } from '@noom/wax-component-library';
import { toHumanString } from '../../../helpers/toHumanString';
import customizableComponent from '../../../core/hocs/customization';
import ConditionalRender from '../../../core/components/ConditionalRender';
import PostLikeButton from '../../../social/components/post/LikeButton';
import CommentComposeBar from '../../../social/components/CommentComposeBar';
import { SecondaryButton } from '../../../core/components/Button';
import { EngagementBarContainer, Counters, InteractionBar, CommentIcon, NoInteractionMessage, } from './styles';
import CommentList from '../../../social/components/CommentList';
const COMMENTS_PER_PAGE = 3;
const COMMENT_PLACEHOLDER_HEIGHT = 135;
const UIEngagementBar = ({ postId, targetType, totalLikes, totalComments, readonly, isHighlighted, onClickComment, showComments, isCommentingEnabled, isComposeBarDisplayed, handleAddComment, handleCopyCommentPath, }) => (React.createElement(EngagementBarContainer, null,
    React.createElement(Counters, { isHighlighted: isHighlighted },
        totalLikes > 0 && (React.createElement("span", { "data-qa-anchor": "engagement-bar-like-counter" },
            toHumanString(totalLikes),
            ' ',
            React.createElement(FormattedMessage, { id: "plural.like", values: { amount: totalLikes } }))),
        showComments && totalComments > 0 && (React.createElement("span", { "data-qa-anchor": "engagement-bar-comment-counter" },
            toHumanString(totalComments),
            ' ',
            React.createElement(FormattedMessage, { id: "plural.comment", values: { amount: totalComments } })))),
    React.createElement(ConditionalRender, { condition: !readonly },
        React.createElement(React.Fragment, null,
            React.createElement(InteractionBar, null,
                React.createElement(PostLikeButton, { postId: postId }),
                React.createElement(SecondaryButton, { "data-qa-anchor": "engagement-bar-comment-button", onClick: onClickComment, isDisabled: !isCommentingEnabled },
                    React.createElement(CommentIcon, null),
                    " ",
                    React.createElement(FormattedMessage, { id: "comment" }))),
            !isCommentingEnabled && (React.createElement(NoInteractionMessage, { noMargin: true },
                React.createElement(FormattedMessage, { id: "post.disabledComments" }))),
            isComposeBarDisplayed && (React.createElement(CommentComposeBar, { postId: postId, postType: targetType, onSubmit: handleAddComment, onCancel: onClickComment })),
            showComments && (React.createElement(LazyRender, { idleTimeout: 0, lazyBehavior: "keepMounted", visibleOffset: 500, placeholderHeight: Math.min(totalComments, COMMENTS_PER_PAGE) * COMMENT_PLACEHOLDER_HEIGHT },
                React.createElement(CommentList, { referenceId: postId, referenceType: CommentReferenceType.Post, last: COMMENTS_PER_PAGE, handleCopyCommentPath: handleCopyCommentPath, isCommentingEnabled: isCommentingEnabled })))),
        React.createElement(React.Fragment, null,
            React.createElement(NoInteractionMessage, null,
                React.createElement(FormattedMessage, { id: "community.cannotInteract" })),
            React.createElement(CommentList, { referenceId: postId, referenceType: CommentReferenceType.Post, last: COMMENTS_PER_PAGE, readonly: true, loadMoreText: React.createElement(FormattedMessage, { id: "collapsible.viewAllComments" }), handleCopyCommentPath: handleCopyCommentPath })))));
UIEngagementBar.propTypes = {
    postId: PropTypes.string,
    targetType: PropTypes.string,
    totalLikes: PropTypes.number,
    totalComments: PropTypes.number,
    readonly: PropTypes.bool,
    isComposeBarDisplayed: PropTypes.bool,
    handleAddComment: PropTypes.func,
    onClickComment: PropTypes.func,
    handleCopyCommentPath: PropTypes.func,
    isHighlighted: PropTypes.bool,
    showComments: PropTypes.bool,
    isCommentingEnabled: PropTypes.bool,
};
UIEngagementBar.defaultProps = {
    postId: '',
    targetType: '',
    totalLikes: 0,
    totalComments: 0,
    readonly: false,
    onClickComment: () => { },
    isComposeBarDisplayed: false,
    handleAddComment: () => { },
};
export default customizableComponent('UIEngagementBar', UIEngagementBar);
//# sourceMappingURL=UIEngagementBar.js.map